import React from 'react';
import cx from 'classnames';
import {EntityType} from '../../features/Form/consts/EntityTypes';
import styles from './styles.module.scss';
import {getEntityIcon} from './actionIconData';

export type Props = {
    type: EntityType;
    componentClasses?: string;
    imgClasses?: string;
    width?: number;
    disabled?: boolean;
};

export const ActionIcon = ({type, componentClasses, imgClasses, width = 19, disabled}: Props) => {
    const iconData = getEntityIcon(type);
    const SvgIcon = iconData.img;
    return (
        <div
            className={cx(styles.wrapper, iconData.className, componentClasses, {
                [styles.disabled]: disabled
            })}
        >
            {<SvgIcon />}
        </div>
    );
};
